const ru = {
  message: {
    newsPage: {
      title: 'Новости'
    },
    documentsPage: {
      title: 'Документы',
      documents: {
        offer: 'Оферта ОАО Паритетбанк',
        rules: 'Правила работы Сервиса (ред. до 14.11.2023)',
        newRules: 'Правила работы Сервиса (ред. 15.11.2023)',
        scoring: 'Положение о скоринге',
        serviceContract: 'Договор возмездного оказания услуг (ред. до 14.11.2023)',
        newServiceContract: 'Договор возмездного оказания услуг (ред. 15.11.2023)',
        personalDataProcessing: 'Политика обработки персональных данных',
        personalDataAgreement: 'Согласие на обработку персональных данных',
        contractTemplate: 'Договор займа (образец, ред. до 14.11.2023)',
        newContractTemplate: 'Договор займа (образец, ред. 15.11.2023)'
      }
    },
    messagesPage: {
      placeholder: 'Написать сообщение',
      btn: 'Отправить',
      tostMsg: 'Сообщение успешно отправлено'
    },
    settingsPage: {
      btn: 'Изменить пароль'
    },
    loanPage: {
      back: 'Назад',
      title: 'Мои займы',
      notice: '* - без учёта комиссий',
      items: {
        date: 'Дата транзакции',
        amount: 'Сумма транзакции*',
        total: 'В т.ч. ОД',
        percent: 'В т.ч. %',
        peni: 'В т.ч. пени'
      }
    },
    changePasswordPage: {
      btnSave: 'Сохранить',
      btnCancel: 'Отмена',
      oldPassword: {
        label: 'Старый пароль'
      },
      newPassword: {
        label: 'Новый пароль'
      },
      confirmPassword: {
        label: 'Подтверждение нового пароля'
      },
      toastMsg: 'Пароль успешно изменен'
    },
    arbitrationPage: {
      title: 'Третейский суд',
      desc: 'Свидетельство № 20 выдано Главным Управлением Юстиции Мингорисполкома',
      license: {
        begin: 'Главное управление юстиции Мингорисполкома 02.11.2022 поставило на учет и внесло в ',
        link: 'реестр',
        end: ' третейских судов Республики Беларусь постоянно действующий третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии». Председателем третейского суда избран Берёзкин Вадим Викторович.'
      },
      contact: {
        title: 'Реквизиты / Контакты',
        items: {
          first: {
            title: 'Реквизиты для оплаты третейского сбора:',
            data: [
              'ООО "ИФС" (УНП 193601287)',
              'ОКПО 505592505000',
              'Р/с: BY18 POIS 3012 0139 1603 0193 3002 в ОАО "Паритетбанк"',
              'BIC: POISBY2X',
              'Назначение платежа: Третейский сбор по иску (Ф.И.О. истца) к (Ф.И.О. ответчика)'
            ],
            documentFirst: 'Тарифы суда',
            documentSecond: 'Регламент'
          },
          second: {
            title: 'Место нахождения:',
            data: '220030, г. Минск, ул. Янки Купалы, д. 25, офис 304'
          },
          third: {
            title: 'Телефон',
            data: '+375 (33) 696 09 09'
          },
          fourth: {
            title: 'Email:',
            data: 'court@ifs.by'
          }
        }
      },
      purpose: {
        title: 'Что такое третейский суд:',
        items: [
          'Третейский суд — организация, не входящая в судебную систему Республики Беларусь, создаваемая для разрешения споров, образуемого по соглашению сторон для разрешения конкретного спора.',
          'Третейское соглашение — это двусторонняя сделка, которая порождает у её сторон обязанность в случае спора обратиться в указанный в соглашении третейский суд.',
          'Решение третейского суда вступает в законную силу в день его принятия и подлежит обязательному исполнению в соответствии с законодательством Республики Беларусь. Решение третейского суда, не исполненное добровольно в установленный срок, подлежит принудительному исполнению в порядке, установленном законодательством об исполнительном производстве.',
          'Третейское соглашение не ограничивает истца в праве на обращение в государственный суд. Однако если ответчик не позднее своего первого заявления по существу спора заявит ходатайство о его передаче на разрешение третейского суда, это станет основанием оставить исковое заявление без рассмотрения.'
        ]
      },
      advantages: {
        title: 'Преимущества третейского суда:',
        items: [
          'простая и быстрая процедура',
          'решения третейского суда окончательны и не подлежат обжалованию',
          'разбирательства проходит по месту нахождения третейского суда в г. Минске, а не по месту нахождения ответчика',
          'решения третейского суда исполняются судебными исполнителями принудительно, на основании полученного в суде общей юрисдикции исполнительного листа'
        ]
      },
      advices: {
        title: 'Практические советы:',
        items: {
          first: 'При невозврате денежных средств в установленный срок у Займодавца возникает право на обращение в суд. Следует учитывать, что в соответствии с условиями договора займа и третейской оговоркой предусмотрен обязательный претензионный порядок и определён суд для рассмотрения споров — постоянно действующий третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии».',
          second: {
            begin: 'Воспользовавшись инструментами Сервиса можно сформировать Претензию, которая будет направлена Заёмщику (должнику). ',
            bold: 'Обращаем внимание на то, что максимальный размер начисляемых пеней по займу составляет 50% от суммы основного долга. Рекомендуем дождаться предусмотренного начисления и затем сформировать Претензию.',
            end: ' Если не дожидаться начисления максимального размера пеней, предусмотренного договором займа, то и подать иск можно на тот размер требований, которые были определены фактической Претензией на дату её составления. В течении 10 дней с момента направления претензии Заёмщиком (должником) должен быть дан ответ Займодавцу на претензию и/или погашены требования.'
          },
          third: 'При отсутствии ответа на Претензию и/или отсутствии погашения требований и истечении 10 дневного срока ответа на Претензию Займодавец имеет право обратиться в суд, воспользовавшись инструментами Сервиса по составлению и отправке Искового заявления в третейский суд Общества с ограниченной ответственностью «Инновационные Финансовые Стратегии».',
          fourth: {
            beginBold: 'В момент подачи Искового заявления должен быть оплачен по ',
            firstLink: 'реквизитам третейского суда',
            middleBold: ' в соответствии с ',
            secondLink: 'тарифами третейского суда',
            endBold: ' третейский сбор за рассмотрение искового заявления (как правило — 2 БВ) и прикреплён скрин (фото) чека оплаты третейского сбора.'
          }
        }
      }
    },
    aboutPage: {
      title: 'О нас',
      desc: {
        title: 'Капуста — онлайн-заимствования',
        items: {
          first: 'ООО «ИФС» (Оператор сервиса онлайн-заимствования) оказывает платные услуги по созданию условий для заключения и исполнения посредством сервиса онлайн-заимствования договоров займа денежных средств и договоров, заключенных в обеспечение исполнения обязательств по договору займа денежных средств в соответствии с утвержденными Правилами сервиса потребительского онлайн-заимствования «Капуста — онлайн-заимствования», условиями договора возмездного оказания услуг и тарифами сервиса.',
          second: {
            begin: '«Капуста — онлайн-заимствования» — это автоматизированный сервис онлайн-заимствования, который начал свою работу в ',
            important: 'мае 2023 года.',
            end: ' Сегодня сервис доступен для заёмщиков и займодавцев по всей Беларуси.'
          },
          third: {
            begin: 'В настоящий момент ',
            bold: '«Капуста — онлайн-заимствования» представлен сервисом потребительского онлайн-заимствования.',
            middle: ' Таким образом участниками данного сервиса в соответствии с Правилами работы данного сервиса могут быть только физические лица (подробнее — ',
            link: 'см.Правила',
            end: ').'
          },
          fourth: 'Предоставление денежных средств в займ посредством сервиса онлайн-заимствования и заключение договоров в обеспечение исполнения обязательств по договору займа денежных средств носят рисковый характер.',
          fifth: 'Оператор сервиса онлайн-заимствования не является стороной по заключаемым посредством этого сервиса онлайн-заимствования договору займа денежных средств и договору, заключенному в обеспечение исполнения обязательств по договору займа денежных средств.',
          sixth: 'Оператор сервиса онлайн-заимствования также не вправе привлекать на свои банковские счета и аккумулировать денежные средства клиентов для их последующего направления заемщикам, иным образом участвовать в движении денежных средств при осуществлении расчетов по договорам займа денежных средств.'
        }
      },
      values: {
        title: 'Наши ценности',
        data: 'Миссия ООО «ИФС» — повышение доступности финансовых услуг и защиты прав их потребителей, а также формирования условий для дальнейшего развития предпринимательства и деловой инициативы.'
      },
      different: {
        title: 'Что отличает нас от других?',
        items: [
          {
            count: 'first',
            title: 'Экспертиза',
            data: 'Мы успешно представляем услуги с 2023 года, используя лучший опыт и методики финансового рынка, привнося и откликаясь современным условиям.'
          },
          {
            count: 'second',
            title: 'Роботизация',
            data: 'Мы используем в т.ч. автоматизированные технологии при работе с клиентами.'
          },
          {
            count: 'third',
            title: 'P2P платформа',
            data: 'У нас есть собственная автоматизированная платформа «Капуста — онлайн-заимствования» в Республике Беларусь.'
          },
          {
            count: 'fourth',
            title: 'Устойчивый бизнес',
            data: 'Мы всегда стремимся развиваться: улучшать существующие процессы и создавать новые продукты и услуги.'
          },
          {
            count: 'fifth',
            title: 'Экология',
            data: 'Мы стремимся минимизировать воздействие нашей деятельности на окружающую среду. Мы регулируем потребление энергии в офисах, предотвращая чрезмерное использование энергии. Большая часть нашего бизнеса безбумажна, большинство документации хранится в цифровом виде в облачных хранилищах. Мы поддерживаем практику в т.ч. удалённой работы наших сотрудников, чтобы сократить выбросы углекислого газа при поездке на работу и домой.'
          },
          {
            count: 'sixth',
            title: 'Наши люди',
            data: 'Своим успехом мы обязаны нашим работникам. Сотрудники свободно могут пользоваться личным рабочим пространством и предоставленными девайсами, а также зоной отдыха. Наши сотрудники активно проходят различные курсы в целях повышения квалификации. В целях поощрения успешной работы предусмотрены различные бонусы, премии и командировки от имени компании. '
          },
          {
            count: 'seventh',
            title: 'Наши клиенты',
            data: 'Мы стремимся создать удобную финансовую экосистему, чтобы обеспечить реальные финансовые возможности.'
          },
          {
            count: 'eleventh',
            title: 'Управление',
            data: 'Безопасность и прозрачность деятельности является одними из ключевых аспектов нашей работы. Наша компания придерживается установленной политики, касающейся противодействия коррупции, мошенничеству, отмыванию денег, а также по сохранению и конфиденциальности данных. Ежеквартально мы формируем отчётность о деятельности сервиса онлайн-заимствования в Национальный банк Республики Беларусь, а также ежегодно публикуем необходимые финансовые отчёты.'
          }
        ]
      },
      contact: {
        title: 'Раскрытие информации',
        items: {
          first: {
            title: 'Полное наименование организации:',
            data: 'Общество с ограниченной ответственностью «Инновационные Финансовые Стратегии» Сокращенное наименование организации: ООО «ИФС»'
          },
          second: {
            title: 'Дата и номер государственной регистрации:',
            data: 'Общество с ограниченной ответственностью «Инновационные Финансовые Стратегии» зарегистрировано Минским горисполкомом 18 ноября 2021 г. №193601287',
            documentFirst: 'Свидетельство о гос. регистрации',
            middleDataBegin: 'Свидетельство № 1 о включении в ',
            link: 'реестр',
            middleDataEnd: ' Операторов сервисов онлайн-заимствования, выдано Национальным банком Республики Беларусь 14.01.2022. Таким образом Обществу с ограниченной ответственностью «Инновационные Финансовые Стратегии» присвоен статус Оператора сервиса онлайн-заимствования.',
            documentSecond: 'Свидетельство о включении в реестр'
          },
          third: {
            title: 'Учредителями Общества являются:',
            items: {
              first: '— Овчаров Роман Юрьевич, Республика Беларусь;',
              second: '— Общество с ограниченной ответственностью Инвестиционная Компания «ПИФАГОР» (Российская Федерация)',
              secondWithHalf: '— Общество с ограниченной ответственностью «ОЛИМП Групп» (Российская Федерация)',
              third: 'Бенефициарные владельцы ООО ИК «ПИФАГОР»: Sabr Limited (Seychelles)',
              fourth: 'Бенефициарный владелец Sabr Limited: Тарханова Ульяна Анатольевна (Российская Федерация)',
              fifth: 'Бенефициарный владелец ООО «ОЛИМП Групп»: Беляков Александр Алексеевич (Российская Федерация)'
            },
            documentFirst: 'Устав',
            documentSecond: 'Уведомление о смене местонахождения',
            documentThird: 'Годовая бухгалтерская отчётность'
          },
          fourth: {
            title: 'Адреса и реквизиты:',
            items: {
              first: '220030, г. Минск, ул. Янки Купалы, д. 25, офис 304',
              second: {
                text: 'e-mail: ',
                link: 'info@kapysta.by'
              },
              third: 'Тел: +375 (25) 908-08-08 (Viber, Telegram, WhatsApp)',
              fourth: '+375 (25) 609-09-09'
            }
          },
          fifth: {
            title: 'Банковские реквизиты:',
            items: {
              first: 'Р/с: BY95 MMBN 3012 0000 0101 0208 4970',
              second: 'в ОАО «Банк Дабрабыт»',
              third: '220002, г.Минск, ул. Коммунистическая, д.49, пом.1',
              fourth: 'BIC MMBNBY22',
              fifth: 'УНП: 193601287',
              sixth: 'ОКПО 505592505000'
            }
          }
        }
      }
    },
    questionsPage: {
      title: 'Частые вопросы',
      items: {
        first: {
          title: 'Как получить деньги (займ)?',
          text: {
            first: {
              begin: 'Для получения займа необходимо ',
              link: 'Зарегистрироваться',
              end: ' на нашем сайте и иметь платёжную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.'
            },
            second: 'Не позднее следующего рабочего дня с момента регистрации и предоставления согласия на проверку кредитной истории вам, как Заёмщику будет присвоена рейтинговая оценка на основании ваших данных, после чего вы сможете совершать сделки займа на нашем сервисе.',
            third: {
              begin: 'Все активные предложения по займам размещены на главной странице сайта. Можно воспользоваться предложениями ',
              link: '«Они готовы выдать деньги прямо сейчас»',
              end: ' и выбрать те условия займа, которые являются приемлемыми для вас.'
            },
            fourth: 'Перед перечислением денежных средств вам будет предложено ознакомиться с условиями и подписать договор займа. В момент зачисления вам денежных средств будет отправлено сообщение на указанный вами емайл.',
            fifth: {
              begin: 'После получения займа внимательно отнеситесь к своевременному погашению займа, т.к. по каждой сделке займа ',
              bold: 'подаётся информация в Кредитный регистр Национального банка Республики Беларусь и ваша платёжная дисциплина будет влиять на вашу кредитную историю.',
              middle: ' Кредитный отчет (кредитную историю) в виде документа на бумажном носителе можно получить в Управлении «Кредитный регистр» Национального банка Республики Беларусь, а также в виде электронного документа посредством ',
              link: 'веб-портала Кредитного регистра',
              end: ' в глобальной компьютерной сети Интернет.'
            },
            sisxth: 'Все сведения о заключённых сделках займа будут отражаться в вашем «Профиле» на сайте. Там же следует производить оплаты, связанные с погашением займа.'
          }
        },
        second: {
          title: 'Как инвестировать (выдать займ)?',
          text: {
            first: {
              begin: 'Для возможности инвестировать (совершать сделки займа) необходимо ',
              link: 'Зарегистрироваться',
              end: ' на нашем сайте и иметь платежную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.'
            },
            second: 'Физические лица могут совершать неограниченное число сделок займов в календарном месяце на сервисе онлайн-заимствования.',
            third: {
              begin: 'Чтобы создать свое предложение на займ, следует воспользоваться инструментами сайта по созданию заявки в своем «Профиле». Обратите внимание, что выбрав ',
              bold: 'количество займов (публикаций) ваше предложение будет публиковаться исходя из заявленного вами числа раз. Соответственно такое количество займов может быть выдано вами ',
              end: '(в т.ч. автоматически) на аналогичных условиях, если на него откликнутся Заёмщики.'
            },
            fourth: 'Если вы хотите создать предложение с иными условиями, нужно создать новую заявку (предложение) и указать также количество ее публикаций.',
            fifth: {
              begin: 'Обратите внимание, что срок размещения на сайте предложения (заявки) может быть ограничен ',
              important: '30-ю днями',
              end: ', после чего оно будет снято с публикации автоматически.'
            },
            sixth: {
              begin: 'Все активные предложения по займам размещены на главной странице сайта.',
              bold: '«Они готовы взять деньги прямо сейчас»',
              end: ' и выбрать те условия займа, которые являются приемлемыми для вас.'
            },
            seventh: {
              begin: 'Фактическим перечислением денежных средств по заявке (оферте) вы присоединяетесь к договору займа, подписанному непосредственно Заемщиком. Ознакомиться с образцом договора займа можно в разделе ',
              bold: '«Документы»',
              end: ' на сайте.'
            },
            eighth: 'Все сведения о заключенных сделках займа будут отражаться в вашем «Профиле» на сайте. Там же будут отражаться все оплаты, связанные с погашением займа.',
            nineth: {
              begin: 'В случае наступления просрочки на неоплаченную часть будут начисляться пени исходя из двукратной ставки процентов по займу, но не более 50% от суммы основного долга. При длительных просрочках (свыше 30-90 дней) рекомендуем обратиться за взысканием (подробнее – см. ',
              bold: 'Третейский суд',
              end: ').'
            }
          }
        },
        third: {
          title: 'Что обозначает рейтинг (скоринговая оценка) Заемщика?',
          text: {
            first: {
              begin: 'Порядок, критерии и методика скоринга регулируются ',
              link: 'Положением о порядке проведения оценки платежеспособности физических лиц – клиентов сервиса потребительского онлайн-заимствования «Капуста – онлайн-заимствования», присвоении скоринговой оценки.',
            },
            second: {
              begin: 'Скоринговая оценка – результат комплексной финансовой оценки способности Заемщика надлежащим образом исполнить свои обязательства, осуществляемой Оператором на основании анкетных данных Заемщика и анализа ретроспективных данных: информации из Кредитного регистра (КР), информации из ОПИ, истории заимствований на Сервисе. Скоринговая оценка определяется по шкале от 0 до 100 баллов, ',
              bold: 'где 100 – наивысшая оценка вероятности Заемщика надлежащим образом исполнить свои обязательства.'
            },
            third: {
              begin: 'Наличие у Заемщика скоринговой оценки ',
              bold: 'от 1 до 20 баллов ',
              end: '– с высокой вероятностью говорит о наличии текущих просрочек в банках и иных учреждениях свыше 90 дней и (или) открытых исполнительных производствах в ОПИ (о принудительном взыскании долга), указывающей на данные обстоятельства кредитной истории в КР, низкого уровня дохода, рабочей специальности, среднего и (или) средне-специального образования Заемщика, отсутствии в собственности недвижимости и (или) автомобиля и наличии иждивенцев и (или) обязанности возмещать расходы, затраченные государством на содержание детей.'
            },
            fourth: {
              begin: 'Наличие у Заемщика скоринговой оценки ',
              bold: 'от 21 до 40 баллов ',
              end: '– с высокой вероятностью говорит о наличии текущих просрочек в банках и иных учреждениях от 30 до 90 дней и (или) открытых исполнительных производствах в ОПИ (о принудительном взыскании долга), указывающей на данные обстоятельства кредитной истории в КР и (или) возрасте Заемщика до 30 лет, низкого уровня дохода, среднего и (или) средне-специального образовании Заемщика, рабочей специальности, отсутствии в собственности недвижимости и (или) наличии иждивенцев.'
            },
            fifth: {
              begin: 'Наличие у Заемщика скоринговой оценки ',
              bold: 'от 41 до 69 баллов ',
              end: '– с высокой вероятностью говорит о наличии текущей просрочки до 7 дней и (или) в прошлом факта допущения просрочек в банках и иных учреждениях до 30 дней, указывающей на данные обстоятельства кредитной истории в КР, среднего уровня дохода, вероятном наличии водительских прав и (или) автомобиля в собственности.'
            },
            sixth: {
              begin: 'Наличие у Заемщика скоринговой оценки ',
              bold: 'от 70 до 100 баллов ',
              end: '– с высокой вероятностью говорит об удовлетворительной кредитной истории в КР, заявленном уровне дохода свыше 1800 бел.рубл., возрасте Заемщика от 31-50 лет, высшем образовании, наличии водительских прав и (или) автомобиля и (или) недвижимости в собственности и (или) успешно завершенных 2 и более сделках займов на Сервисе (при их наличии без допущения просрочек).'
            }
          }
        }
      }
    },
    investingPage: {
      heading: {
        title: 'Капуста — лучшее решение!',
        firstDesc: 'Используя наш сервис вы получаете альтернативную возможность инвестирования. Теперь заключение сделок займов возможно онлайн, 24/7, на условиях, которые вы выбираете сами'
      },
      advantages: {
        title: 'Почему все выбирают Капусту:',
        items: {
          first: 'Выдача и погашение займа круглосуточно',
          second: 'Вы сами выбираете условия, сумму и срок займа',
          third: 'За просроченный платёж в вашу пользу начисляются пени',
          fourth: 'SSL сертификат, защита личной информации',
          fifth: 'Справочно-информационная поддержка',
          sixth: 'Взыскание в третейском суде'
        }
      },
      hiw: {
        title: 'Три простых шага для получения денег:',
        first: {
          title: 'Регистрация',
          desc: 'через МСИ займёт не более 5 минут.  Вы становитесь полноценным участником Сервиса и владельцем личного "карманного" Банка'
        },
        second: {
          title: 'Выдача займа',
          desc: 'для выдачи займа создайте свои уникальные предложения по займам, воспользовавшись инструментами Сервиса'
        },
        third: {
          title: 'Подпись договора',
          desc: 'договор займа является реальным договором. Перечислением денежных средств вы присоединяетесь к условиям договора'
        }
      },
      memo: {
        title: 'Памятка для Займодавцев',
        items: {
          first: {
            begin: 'Для возможности инвестировать (совершать сделки займа) необходимо ',
            link: 'Зарегистрироваться',
            end: ' на нашем сайте и иметь платежную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.'
          },
          second: 'Физические лица могут совершать неограниченное число сделок займов в календарном месяце на сервисе онлайн-заимствования.',
          third: {
            begin: 'Чтобы создать свое предложение на займ, следует воспользоваться инструментами сайта по созданию заявки в своем «Профиле». Обратите внимание, что выбрав ',
            bold: 'количество займов (публикаций) ваше предложение будет публиковаться исходя из заявленного вами числа раз. Соответственно такое количество займов может быть выдано вами',
            end: ' (в т.ч. автоматически) на аналогичных условиях, если на него откликнутся Заёмщики.'
          },
          fourth: 'Если вы хотите создать предложение с иными условиями, нужно создать новую заявку (предложение) и указать также количество ее публикаций.',
          fifth: {
            begin: 'Обратите внимание, что срок размещения на сайте предложения (заявки) может быть ограничен ',
            important: '30-ю днями',
            end: ', после чего оно будет снято с публикации автоматически.'
          },
          sixth: {
            begin: 'Все активные предложения по займам размещены на главной странице сайта.',
            beginImportant: ' Также можно воспользоваться заявками Заемщиков ',
            link: '«Они готовы взять деньги прямо сейчас»',
            endImportant: ' и выбрать те условия займа, которые являются приемлемыми для вас.'
          },
          seventh: {
            begin: 'Фактическим перечислением денежных средств по заявке (оферте) вы присоединяетесь к договору займа, подписанному непосредственно Заемщиком. Ознакомиться с образцом договора займа можно в разделе ',
            link: '«Документы»',
            end: ' на сайте.'
          },
          eighth: 'Все сведения о заключенных сделках займа будут отражаться в вашем «Профиле» на сайте. Там же будут отражаться все оплаты, связанные с погашением займа.',
          ninth: {
            begin: 'В случае наступления просрочки на неоплаченную часть будут начисляться пени исходя из двукратной ставки процентов по займу, но не более 50% от суммы основного долга. При длительных просрочках (свыше 30-90 дней) рекомендуем обратиться за взысканием (подробнее – см. ',
            link: 'Третейский суд',
            end: ').'
          }
        },
        note: {
          begin: 'Справочно: Кредитный отчет (кредитную историю) в виде документа на бумажном носителе можно получить в Управлении «Кредитный регистр» Национального банка Республики Беларусь, а также в виде электронного документа посредством ',
          link: 'веб-портала Кредитного регистра',
          end: ' в глобальной компьютерной сети Интернет.'
        }
      },
      signUp: {
        title: 'Зарегистрируйтесь прямо сейчас!',
        btn: 'Зарегистрироваться'
      }
    },
    getLoanPage: {
      heading: {
        title: 'Капуста — лучшее решение!',
        firstDesc: 'Самый быстрый и удобный выход из ситуации, когда срочно нужны деньги — оформить займ в Капусте.',
        secondDesc: 'Получение Займа доступно с любой кредитной историей. В Капусте легко могут получить деньги даже те, кому отказали в банке, а также студенты, пенсионеры и временно безработные. Вам не потребуются справки, страховка и залог. Займ предоставляется на любую карту и без визитов в отделение банка. От вас потребуется только наличие компьютера или мобильного телефона.'
      },
      advantages: {
        title: 'Почему все выбирают Капусту:',
        items: {
          first: 'БЕЗ: справок, залогов, страховок и поручителей',
          second: 'Круглосуточно: потребуется только мобильный телефон',
          third: 'Вы сами выбираете условия, сумму и срок займа',
          fourth: 'Вы платите проценты только за дни пользования займом',
          fifth: 'SSL сертификат, защита личной информации',
          sixth: 'Возможность улучшить свой  рейтинг в Капусте'
        }
      },
      hiw: {
        title: 'Три простых шага для получения денег:',
        first: {
          title: 'Регистрация',
          desc: 'через МСИ займёт не более 5 минут.  Вы становитесь полноценным участником Сервиса и владельцем личного "карманного" Банка'
        },
        second: {
          title: 'Получение займа',
          desc: 'все сделки займов заключаются напрямую между физическими лицами. Для получения денег воспользуйтесь предложениями от Займодавцев и сделайте свой выбор'
        },
        third: {
          title: 'Подпись договора',
          desc: 'осуществляется с помощью аналога собственноручной подписи (просто введите код из SMS- или PUSH-уведомления)'
        }
      },
      memo: {
        title: 'Памятка для Заёмщиков',
        items: {
          first: {
            begin: 'Для получения займа необходимо ',
            link: 'Зарегистрироваться',
            end: ' на нашем сайте и иметь платёжную карточку любого белорусского банка в белорусских рублях, поддерживающую сервис р2р-переводов.'
          },
          second: 'Не позднее следующего рабочего дня с момента регистрации и предоставления согласия на проверку кредитной истории вам, как Заёмщику будет присвоена рейтинговая оценка на основании ваших данных, после чего вы сможете совершать сделки займа на нашем сервисе.',
          third: {
            begin: 'Все активные предложения по займам размещены на главной странице сайта. Можно воспользоваться предложениями ',
            link: '«Они готовы выдать деньги прямо сейчас»',
            end: ' и выбрать те условия займа, которые являются приемлемыми для вас.'
          },
          fourth: 'Перед перечислением денежных средств вам будет предложено ознакомиться с условиями и подписать договор займа. В момент зачисления вам денежных средств будет отправлено сообщение на указанный вами емайл.',
          fifth: {
            begin: 'После получения займа внимательно отнеситесь к своевременному погашению займа, т.к. по каждой сделке займа ',
            end: 'подаётся информация в Кредитный регистр Национального банка Республики Беларусь и ваша платёжная дисциплина будет влиять на вашу кредитную историю.'
          },
          sixth: 'Все сведения о заключённых сделках займа будут отражаться в вашем «Профиле» на сайте. Там же следует производить оплаты, связанные с погашением займа.'
        },
        note: {
          begin: 'Справочно: Кредитный отчет (кредитную историю) в виде документа на бумажном носителе можно получить в Управлении «Кредитный регистр» Национального банка Республики Беларусь, а также в виде электронного документа посредством ',
          link: 'веб-портала Кредитного регистра',
          end: ' в глобальной компьютерной сети Интернет.'
        }
      },
      signUp: {
        title: 'Зарегистрируйтесь прямо сейчас!',
        btn: 'Зарегистрироваться'
      }
    },
    legislation: {
      title: 'Законодательство',
      firstRow: 'Данный раздел не имеет статуса юридической базы. Публикация нормативных правовых актов, ссылок на них носит справочный, информационный характер.',
      secondRow: {
        firstText: 'Для ознакомления с нормативными правовыми актами можно перейти по ссылке:',
        link: 'Законодательство о сервисах онлайн-заимствования',
        secondText: 'Перейдя по ссылке вы покидаете наш сайт'
      }
    },
    contacts: {
      title: 'Контакты',
      address: {
        title: 'Адрес местонахождения:',
        data: '220030, г. Минск, БЦ «Журавинка», ул. Янки Купалы 25, офис 304'
      },
      postalAddress: {
        title: 'Почтовый адрес :',
        data: '220030, г. Минск, БЦ «Журавинка», ул. Янки Купалы 25, офис 304'
      },
      time: {
        title: 'Время работы офиса:',
        week: 'Понедельник - Пятница',
        data: 'с 09:00 до 18:00'
      },
      phones: {
        title: 'Телефоны:',
        first: '+375 (25) 908-08-08 (Viber, Telegram, WhatsApp)',
        second: '+375 (25) 609-09-09'
      },
      support: {
        title: 'Служба поддержки:',
        data: 'support@kapysta.by'
      }
    },
    contract: {
      otp: {
        placeholder: 'Введите код из SMS'
      },
      successModal: {
        title: 'Поздравляем!',
        desc: {
          text: 'Займ зачислен на вашу карту. Сделка отражена в ',
          link: 'Профиле'
        },
        btn: 'OK'
      },
      errorModal: {
        title: 'Внимание!',
        desc: 'Не удалось зачислить денежные  средства. Ранее подписанный вами договор займа аннулируется.',
        btn: 'OK'
      },
      btn: 'Подписать договор'
    },
    bid: {
      title: 'Создание заявки',
      currencyList: {
        BYN: 'BYN',
        USD: 'USD'
      },
      currency: {
        title: 'Выбор валюты'
      },
      totalAmount: {
        title: 'Общая сумма',
        placeholder: '10 000 000'
      },
      minAmount: {
        title: 'Мин. сумма займа',
        placeholder: '100'
      },
      aliquote: {
        title: 'Кратность сумме'
      },
      percent: {
        title: '% годовых',
        placeholder: '12,5%'
      },
      terms: {
        title: 'Срок займа',
        fromPlaceholder: 'c: 22.03.2023',
        toPlaceholder: 'по: 22.03.2023',
        from: 'с',
        to: 'по'
      },
      relevance: {
        title: 'Актуальность заявки',
        toPlaceholder: 'по: 22.03.2023',
        to: 'по'
      },
      paymentProcedure: {
        title: 'Порядок выплат %',
        list: {
          monthly: 'Ежемесячно',
          quarterly: 'Ежеквартально'
        }
      },
      provision: {
        title: 'Обеспечение',
        yes: 'Да',
        no: 'Нет',
        placeholder: 'Гарантия банка',
        list: {
          bank_guarantee: 'Гарантия банка'
        }
      }
    },
    profile: {
      rate: 'Рейтинг:',
      status: {
        active: 'Активный',
        inactive: 'Не активный',
        waiting: 'В ожидании выставления рейтинга',
        blocked: 'Заблокирован'
      },
      role: {
        title: 'Статус: ',
        lender: 'Займодавец',
        borrower: 'Заёмщик'
      },
      borrower: {
        activeOffers: {
          title: 'Мои займы',
          items: {
            issued: 'Дата выдачи',
            amount: 'Сумма',
            term: 'Срок',
            percent: '% годовых',
            income: 'Сумма к возврату',
            issuedBy: 'Дата возврата',
            peni: 'Пени',
            totalAmount: 'Итого',
            status: 'Статус заявки'
          },
          status: {
            payment: 'Задолженность',
            closed: 'Оплачено',
            expired: 'Просрочено',
            paid: 'Активная',
            on_due: 'Задолженность',
            current_debt: 'Задолженность',
            repaid: 'Оплачено',
            overdue: 'Просрочено',
            payment_pending: 'В ожидании'
          },
          btn: 'Оплатить',
          transactions: 'Транзакции',
          payModal: {
            title: 'Сумма к оплате:',
            currency: 'BYN',
            payBtn: 'Оплатить'
          }
        },
        noCardLink: 'Добавьте',
        noCardText: ' карту, на которую вы хотите получить деньги',
        noRate: '(В данный момент ожидается выставление рейтинга)',
        noScoringAgreement: {
          start: 'Для выставления рейтинга (скоринговой оценки) необходимо ',
          link: 'дать согласие',
          end: ' на предоставление кредитного отчёта из Кредитного регистра'
        }
      },
      lender: {
        offer: {
          amount: {
            title: 'Сумма займа',
            placeholderStart: 'от',
            placeholderEnd: 'до'
          },
          term: {
            title: 'Срок',
            placeholderStart: 'от',
            placeholderEnd: 'до',
            days: 'дней'
          },
          percent: {
            title: '% годовых',
            placeholderStart: 'от',
            placeholderEnd: 'до',
          },
          income: {
            title: 'Доход*'
          },
          rating: {
            title: 'Рейтинг',
            placeholder: 'от 0 до 100'
          },
          count: {
            title: 'Кол-во займов',
            placeholder: '1',
            notice: 'Обратите внимание, что выбрав количество займов (публикаций) ваше предложение будет публиковаться исходя из заявленного вами числа раз. Соответственно такое количество займов может быть выдано вами (в т.ч. автоматически) на аналогичных условиях, если на него откликнутся Заёмщики.'
          },
          btn: 'Создать завку',
          toastMsg: 'Заявка успешно создана',
          publish: 'Опубликовать',
          unpublish: 'Снять с публикации'
        },
        activeOffers: {
          title: 'Мои заявки',
          moreOffers: 'Развернуть ещё',
          items: {
            amount: 'Сумма',
            term: 'Срок',
            percent: '% годовых',
            income: 'Доход*',
            rating: 'Рейтинг',
            count: 'Кол-во займов',
            status: 'Публикация'
          },
          published: {
            yes: 'Да',
            no: 'Нет',
            published: 'Да',
            "not_published": 'Нет',
            blocked: 'Заблокирована'
          },
          publishBtn: {
            published: 'Снять с публикации',
            "not_published": 'Опубликовать'
          }
        },
        expiredLoan: {
          link: 'Создать Претензию',
          text: 'Оформление искового заявления в третейский суд'
        },
        expiredModal: {
          title: 'Вы воспользовались функцией “Создание Претензии”.',
          advicesBtn: 'Практические советы',
          claimBtn: 'Перейти к созданию Претензии'
        },
        noCardLink: 'Добавьте',
        noCardText: ' карту, на которую вы хотите получить деньги',
        noScoringAgreement: {
          start: 'Для выставления рейтинга (скоринговой оценки) необходимо ',
          link: 'дать согласие',
          end: ' на предоставление кредитного отчёта из Кредитного регистра'
        }
      }
    },
    footer: {
      links: {
        about: 'О нас',
        contacts: 'Контакты',
        news: 'Новости',
        docs: 'Документы',
        legal: 'Законодательство',
        justice: 'Третейский суд',
        questions: 'Частые вопросы'
      },
      social: 'Мы в соц. сети:',
      legal: {
        cookies: 'Мы используем сооkies для сбора обезличенных персональных данных. Оставаясь на сайте, Вы соглашаетесь на сбор таких данных. Предоставление займов сопряжено с определенным риском.',
        company: 'ООО «ИФС» (С) Свидетельство № 1 Национального банка Республики Беларусь от 14.01.2022'
      }
    },
    header: {
      signOutBtn: 'Выйти',
      signInBtn: 'Войти',
      getLoan: 'Получить займ',
      returnLoan: 'Вернуть займ',
      investing: 'Инвестировать',
      about: 'О нас',
      register: 'Зарегистрироваться'
    },
    mainPage: {
      heading: {
        title: 'Капуста — сервис онлайн-заимствования',
        desc: {
          link: 'Свидетельство ',
          textStart: '№ 1 Национального банка Республики Беларусь ',
          textEnd: 'о включении в реестр операторов сервисов онлайн-заимствования',
          textNotice: '(Указ Президента Республики Беларусь от 25 мая 2021 г. № 196)'
        },
        btn: 'ЗАРЕГИСТРИРОВАТЬСЯ'
      },
      offers: {
        title: 'Они готовы выдать деньги прямо сейчас!',
        btn: 'Получить деньги',
        tableTitle: {
          amount: 'Сумма',
          return: 'К возвр.',
          returnMobile: 'К возврату',
          issuedBy: 'Срок',
          rating: 'Рейтинг'
        },
        more: 'Раскрыть ещё'
      },
      hiw: {
        title: 'Как работает Капуста:',
        first: {
          title: 'Регистрация',
          desc: 'немного терпения и вы становитесь полноценным участником Сервиса и одновременно владельцем личного «карманного» Банка. Регистрация  через МСИ и для желающих предоставлять займы — гораздо быстрее'
        },
        second: {
          title: 'Получение займа',
          desc: 'все сделки займов заключаются напрямую между физическими лицами. Для получения денег воспользуйтесь предложениями от Займодавцев и сделайте свой выбор'
        },
        third: {
          title: 'Выдача займа',
          desc: 'на нашем сайте вы можете создать свои уникальные предложения по займам. Займодавцы не ограничены в количестве совершаемых сделок на нашем Сервисе'
        }
      },
      advantages: {
        title: 'Почему все выбирают Капусту:',
        items: {
          first: 'БЕЗ: справок, залогов, страховок и поручителей',
          second: '95% вероятность одобрения. Деньги на карту за 15 минут',
          third: 'Выдача и погашение займа круглосуточно',
          fourth: 'SSL сертификат, защита личной информации',
          fifth: 'Справочно-информационная поддержка',
          sixth: 'Взыскание в третейском суде'
        }
      },
      targetLoans: {
        title: 'Присмотритесь к целевым займам, разработанным специально для вас!',
        amount: 'Сумма:',
        time: 'Срок:',
        return: 'К возврату:',
        days: 'дней',
        btn: 'Получить деньги',
        first: 'Простой',
        second: 'До зарплаты',
        third: 'Универсальный',
        fourth: 'Крупная сделка',
        fifth: 'На ремонт',
        sixth: 'На отдых'
      },
      newLoan: {
        title: 'Не нашли подходящего предложения?',
        descFirstRow: 'Хотите получить займ на своих условиях?',
        descSecondRow: 'Создайте свою Уникальную заявку!'
      },
      partners: {
        title: 'Наши партнёры'
      }
    },
    notFound: {
      title: 'Упс!',
      notice: 'Возможно, запрашиваемая страница временно не доступна :(',
      btn: 'Вернуться на главную'
    },
    passwordRecovery: {
      backBtn: 'Вернуться',
      firstStep: {
        title: 'Для того, чтобы восстановить доступ к личному кабинету, укажите свой логин',
        login: {
          label: 'Введите логин',
          btn: 'Далее'
        }
      },
      secondStep: {
        title: 'Письмо с кодом для восстановления пароля отправлено на Ваш Email адрес',
        otp: {
          label: 'Введите код',
          btn: 'Далее'
        }
      },
      thirdStep: {
        title: 'Создание нового пароля',
        password: {
          label: 'Новый пароль'
        },
        repeatPassword: {
          label: 'Новый пароль ещё раз'
        },
        saveBtn: 'Сохранить',
        cancelBtn: 'Отмена'
      }
    },
    docksUploader: {
      errorMsg: 'Необходимо загрузить файлы',
      validationErrorMsg: 'Не верный формат файла',
      downloadBtn: 'Прикрепить файл'
    },
    hello: 'works',
    errorModal: {
      title: 'Ошибка',
      btn: 'OK'
    },
    signUp: {
      signUpBtn: 'Зарегистрироваться',
      isDataFullAndCorrect: {
        text: 'Я подтверждаю полноту и корректность предоставленных мной данных'
      },
      isAgreeWithServiceRules: {
        text: 'Я ознакомлен(а) и согласен(а) с ',
        link: 'Правилами работы Сервиса ',
        secondText: 'и ',
        secondLink: 'Политикой в отношении обработки персональных данных'
      },
      isAgreeWithPersonalDataActions: {
        textFirst: 'Я даю ',
        link: 'согласие',
        textSecond: ' на обработку своих персональных данных'
      },
      isAgreeWithServiceAgreement: {
        textFirst: 'Я ознакомлен и согласен с условиями ',
        link: 'Договора возмездного оказания услуг',
        textSecond: ' и принимаю условия данной оферты'
      },
      isAgreeToGetBankReport: {
        textFirst: 'Даю своё ',
        link: 'согласие на получение отчёта',
        textSecond: ' из Кредитного регистра НБРБ'
      },
      title: 'Анкета',
      description: 'Будьте внимательны на данном этапе. * - обязательны для заполнения',
      basicBlock: {
        title: 'Контактные данные',
        keyWord: {
          title: 'Кодовое слово',
          noticeMsg: 'Может использоваться для подтверждения операций'
        },
        msisdn: {
          title: 'Номер телефона'
        },
        otp: {
          title: 'Код из SMS',
          sendOtp: 'Получить код'
        },
        email: {
          title: 'Email'
        },
        fullName: {
          title: 'Полное наименование*'
        },
        shortName: {
          title: 'Краткое наименование*'
        },
        unp: {
          title: 'УНП*'
        },
        formerName: {
          title: 'Регистрирующий орган*'
        },
        regNumber: {
          title: 'Регистрационный номер*'
        },
        regDate: {
          title: 'Дата регистрации*',
          placeholder: 'ДД/ММ/ГГГГ'
        },
        otpToastMsg: 'Код выслан'
      },
      role: {
        title: 'Выберите статус'
      },
      mainData: {
        title: 'Основные сведения',
        surname: {
          title: 'Фамилия*'
        },
        name: {
          title: 'Имя*'
        },
        middleName: {
          title: 'Отчество',
          noMiddleName: 'Нет отчества'
        },
        birthDate: {
          title: 'Дата рождения',
          placeholder: 'ДД.ММ.ГГГГ'
        },
        citizenship: {
          title: 'Гражданство'
        },
        gender: {
          title: 'Пол',
          male: 'Мужской',
          female: 'Женский'
        },
        birthPlace: {
          title: 'Место рождения',
          placeholder: 'В точном соответствии с паспортными данными'
        }
      },
      passwordBlock: {
        title: 'Логин и пароль',
        login: {
          title: 'Логин*'
        },
        password: {
          title: 'Пароль*'
        }
      },
      addressBlock: {
        title: 'Адрес',
        registrationAdress: {
          title: 'Адрес регистрации (прописка)*',
          theSame: 'Адрес проживания совпадает с адресом регистрации'
        },
        livingAddress: {
          title: 'Адрес проживания',
          placeholder: 'Заполнить, если адрес проживания не совпадает с адресом регистрации'
        },
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList: {
            "112": 'Беларусь',
            "643": 'Россия',
            "3": 'Казахстан'
          }
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      postalAddressBlock: {
        title: 'Почтовый адрес',
        addressTheSame: 'Почтовый адрес совпадает с адресом места нахождения',
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList: {
            112: 'Беларусь',
            643: 'Россия',
            3: 'Казахстан'
          }
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      idBlock: {
        title: 'Данные, удостоверяющие личность',
        idType: {
          title: 'Вид документа*',
          idTypeList: {
            1: 'Паспорт гражданина РБ',
            2: 'Паспорт иностранного гражданина',
            3: 'Вид на жительство',
            4: 'Удостоверение беженца',
            5: 'Идентификационная карта гражданина РБ',
            6: 'Биометрический вид на жительство в РБ',
          }
        },
        idNumber: {
          title: 'Номер документа*'
        },
        idIdentification: {
          title: 'Идентификационный номер (ID)*'
        },
        mainDocument: {
          title: 'Основной документ*',
          placeholder: '',
          list: {
            1: 'Биометрический вид на жительство в РБ',
            2: 'Паспорт иностранного гражданина',
            3: 'Паспорт гражданина РБ',
            4: 'Удостоверение беженца',
            5: 'Идентификационная карта гражданина РБ',
            6: 'Вид на жительство'
          },
        },
        seriesAndNumber: {
          title: 'Серия и номер*',
          placeholder: 'AA1234567'
        },
        idDateIssue: {
          title: 'Дата выдачи*',
          placeholder: 'ДД.ММ.ГГГГ'
        },
        expireDate: {
          title: 'Срок действия документа*',
          placeholder: 'ДД.ММ.ГГГГ'
        },
        idIssuedBy: {
          title: 'Кем выдан*',
          placeholder: 'В точном соответствии с паспортными данными'
        }
      },
      livingAddressBlock: {
        title: 'Адрес места жительства',
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList: {
            112: 'Беларусь',
            643: 'Россия',
            3: 'Казахстан'
          }
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      destinationAddressBlock: {
        title: 'Адрес места пребывания',
        addressTheSame: 'Место пребывания совпадает с местом жительства (регистрации)',
        country: {
          title: 'Страна',
          placeholder: 'Беларусь',
          countryList: {
            112: 'Беларусь',
            643: 'Россия',
            3: 'Казахстан'
          }
        },
        locality: {
          title: 'Населённый пункт*'
        },
        area: {
          title: 'Область*'
        },
        district: {
          title: 'Район*'
        },
        formerName: {
          title: 'Тип населённого пункта*',
          formerNameList: {
            1: 'Агрогородок',
            2: 'Город',
            3: 'Городской поселок',
            4: 'Деревня',
            5: 'Курортный поселок',
            6: 'Поселок',
            7: 'Рабочий поселок',
            8: 'Село',
            9: 'Хутор'
          }
        },
        postalCode: {
          title: 'Почтовый индекс*',
          placeholder: '220022'
        },
        street: {
          title: 'Улица*'
        },
        house: {
          title: 'Дом*'
        },
        building: {
          title: 'Корпус'
        },
        office: {
          title: 'Квартира'
        }
      },
      authorizedPersonBlock: {
        title: 'Данные уполномоченного лица',
        citizen: 'Резидент Республики Беларусь',
        notCitizen: 'Нерезидент Республики Беларусь',
        phone: {
          title: 'Номер телефона*',
          placeholder: '+ 375 (29) 111-11-11'
        },
        basedOn: {
          title: 'На основании чего действует руководитель*'
        },
        surname: {
          title: 'Фамилия*'
        },
        name: {
          title: 'Имя*'
        },
        middleName: {
          title: 'Отчество',
          noMiddleName: 'Нет отчества'
        },
        citizenship: {
          title: 'Гражданство*',
          countryList: {
            112: 'Беларусь',
            643: 'Россия',
            3: 'Казахстан'
          }
        },
        birthplace: {
          title: 'Место рождения*',
          placeholder: 'В точном соответствии с паспортными данными'
        },
        post: {
          title: 'Должность*'
        },
        website: {
          title: 'Адрес сайта в Интернете'
        },
        email: {
          title: 'Адрес электронной почты'
        }
      },
      jobBlock: {
        title: 'Сведения о работе',
        typeOfEmployment: {
          title: 'Вид занятости*',
          list: {
            1: 'Работаю официально',
            2: 'Работаю неофициально',
            3: 'Временно не работаю',
            4: 'В декретном отпуске',
            5: 'Предприниматель',
            6: 'Иной источник дохода',
            7: 'Пенсионер',
            8: 'Работающий пенсионер',
            9: 'Самозанятый',
            10: 'Студент'
          }
        },
        fieldOfEmployment: {
          title: 'Сфера занятости*',
          list: {
            1: 'Банковское дело / финансы',
            2: 'Вооружённые силы / правоохр. органы',
            3: 'Государственное управление',
            4: 'Здравоохранение / фармация',
            5: 'IT',
            6: 'Коммунальное хозяйство',
            7: 'Культура',
            8: 'Наука и образование',
            9: 'Промышленность',
            10: 'Развлечения',
            11: 'Сельское хозяйство',
            12: 'Строительсво',
            13: 'Торговля',
            14: 'Услуги',
            15: 'Работник ИП'
          }
        },
        nameOfOrganization: {
          title: 'Наименование организации*'
        },
        post: {
          title: 'Должность*',
          list: {
            1: 'Специалист',
            2: 'Рабочий',
            3: 'Руководитель среднего звена',
            4: 'Главный бухгалтер',
            5: 'Главный инженер',
            6: 'Заместитель руководителя',
            7: 'Руководитель',
            8: 'Другое'
          }
        },
        otherPositionType: {
          title: 'Введите должность*'
        },
        phoneNumber: {
          title: 'Телефон организации',
          placeholder: '+ 375 (29) 111-11-11'
        },
        workExperience: {
          title: 'Стаж работы в данной организации*',
          placeholder: 'Мес.'
        }
      },
      entityDocsBlock: {
        title: 'Документы юридического лица',
        description: 'Формат загружаемого файла: jpeg, jpg, png, pdf. Максимальный размер 1-го загружаемого файла 5 МБ',
        order: {
          title: '1. Документ, удостоверяющий право уполномоченного лица (приказ, распоряжение)',
          error: 'Необходимо загрузить файлы'
        },
        register: {
          title: '2. Свидетельство о регистрации'
        },
        charter: {
          title: '3. Устав'
        },
        extra: {
          title: '4. Дополнительные файлы'
        }
      },
      roleBlock: {
        borrower: 'Заёмщик',
        lender: 'Займодавец'
      },
      extraBlock: {
        title: 'Дополнительные сведения',
        education: {
          title: 'Образование',
          list: {
            1: 'Незаконченное среднее',
            2: 'Среднее',
            3: 'Средне-специальное',
            4: 'Незаконченное высшее',
            5: 'Высшее'
          }
        },
        driversLicense: {
          title: 'Водительское удостоверение',
          yes: 'Имею',
          no: 'Не имею'
        },
        car: {
          title: 'Автомобиль в собственности',
          yes: 'Имею',
          no: 'Не имею'
        },
        realEstate: {
          title: 'Недвижимость в собственности',
          yes: 'Имею',
          no: 'Не имею'
        },
        familyStatus: {
          title: 'Семейное положение',
          list: {
            1: 'Холост / Не замужем',
            2: 'Женат / Замужем'
          }
        },
        dependensNumber: {
          title: 'Количество иждивенцев*'
        },
        childExpenses: {
          title: 'Обязанность возмещать расходы, затраченные государством на содержание детей (в детских домах, интернатах, спец.учреждениях и пр.)',
          yes: 'Имею',
          no: 'Не имею'
        },
        totalIncome: {
          title: 'Общий ежемесячный доход в BYN*'
        }
      }
    },
    signIn: {
      title: 'Добро пожаловать в Капусту!',
      loginPlaceholder: 'Номер телефона',
      passwordPlaceholder: 'Пароль',
      otpPlaceholder: 'Код из SMS',
      sendCode: 'ОТПРАВИТЬ КОД',
      signInBtn: 'Войти',
      msi: 'Зарегистрироваться',
      forgotPassword: 'Забыли пароль?',
      otpToastMsg: 'Код выслан'
    },
    cardsPage: {
      amountNotice: 'При добавлении карты минимальный остаток должен составлять 1 бел.рубль',
      addEnotherBtn: 'ДОБАВИТЬ ДРУГУЮ КАРТУ',
      addNewBtn: 'ДОБАВИТЬ КАРТУ',
      empty: 'Список карт пуст',
      notVerified: 'Карта не верифицирована',
      card: {
        card: 'Карта',
        expiry: 'Срок действия',
        MIR: 'Мир/ Мгновенное зачисление возможно',
        VISA: 'Visa/ Мгновенное зачисление возможно',
        BELKART: 'BELKART/ Мгновенное зачисление возможно',
        MASTERCARD: 'Mastercard/ Мгновенное зачисление возможно',
        delete: 'Удалить карту'
      },
      deleteCard: {
        title: 'Внимание!',
        text: 'Вы действительно хотите удалить карту?',
        acceptBtn: 'Подтвердить',
        closeBtn: 'Отмена'
      }
    },
    msi: {
      regBtn: 'Продолжить',
      cancelBtn: 'Отмена',
      note: 'Регистрация на нашем сервисе реализована через Межбанковскую Систему Индентификации (МСИ)'
    },
    sideMenu: {
      profile: 'Профиль',
      main: 'Главная',
      cards: 'Мои карты',
      settings: 'Настройки',
      archive: 'Архив',
      notifications: 'Уведомления',
      messages: 'Отправка сообщения администратору',
      "change-password": 'Смена пароля',
      loan: 'Транзакции',
      documents: 'Документы'
    }
  }
}

export default ru;